export default function numberComparator(value1, value2) {
  const number1 = parseFloat(value1)
  const number2 = parseFloat(value2)

  if (number1 === number2 || (number1 === null && number2 === null)) {
    return 0
  }
  if (number1 === null || isNaN(number1)) {
    return -1
  }
  if (number2 === null || isNaN(number2)) {
    return 1
  }

  return number1 > number2 ? 1 : -1
}
